class DirectLiquidSlider {
  constructor() {
    this.currentIndex = 0;
    this.scrollPosition = 0;
    this.imageData = [];
    
    // タッチ判定用
    this.touchStartX = 0;
    this.touchStartY = 0;
    this.touchStartTime = 0;
    
    // サムネイルスワイプ用
    this.thumbnailTouchStartX = 0;
    this.thumbnailTouchStartY = 0;
    this.thumbnailScrollIndex = 0; // 現在のスクロール位置（インデックス）
    this.thumbnailStartScrollPosition = 0; // スワイプ開始時のスクロール位置
    this.thumbnailIsSwiping = false; // スワイプ中かどうか
    
    this.init();
  }

  init() {
    // 既存のoriginal-grid-sectionから直接データ抽出
    this.extractDataFromGridSections();
    
    if (this.imageData.length > 0) {
      // console.log(`🚀 ${this.imageData.length}枚の画像でスライダーを生成します`);
      this.createSliderInterface();
      this.setupEvents();
      this.selectImage(0);
    } else {
      // console.log('ℹ️ 画像データが見つかりませんでした');
      this.showNotAvailable();
    }
  }

  // 既存のoriginal-grid-sectionから直接抽出
  extractDataFromGridSections() {
    const sections = document.querySelectorAll('.original-grid-section');
    
    sections.forEach((section, index) => {
      const img = section.querySelector('.original-img-area img');
      const infoArea = section.querySelector('.original-info-area');
      
      if (img && img.src) {
        const metadata = this.extractInfoFromArea(infoArea);
        
        // 高解像度画像URL生成
        const highResImageUrl = this.generateHighResImageUrl(img.src);
        const srcsetData = this.generateSrcset(img.src);
        
        this.imageData.push({
          src: highResImageUrl,
          srcset: srcsetData.srcset,
          sizes: srcsetData.sizes,
          alt: img.alt || `画像${index + 1}`,
          model: metadata.model || '',
          size: metadata.size || '',
          color: metadata.color || ''
        });
      }
    });
  }

  // 高解像度画像URL生成
  generateHighResImageUrl(originalSrc) {
    // 既存のwidth=500を除去して、高解像度版を生成
    const baseUrl = originalSrc.split('?')[0];
    const urlParams = new URLSearchParams(originalSrc.split('?')[1] || '');
    
    // width=500を削除
    urlParams.delete('width');
    
    // 高解像度用のwidth設定（メイン画像用）
    urlParams.set('width', '1200');
    
    return `${baseUrl}?${urlParams.toString()}`;
  }

  // srcset生成（レスポンシブ対応）
  generateSrcset(originalSrc) {
    const baseUrl = originalSrc.split('?')[0];
    const urlParams = new URLSearchParams(originalSrc.split('?')[1] || '');
    
    // width削除
    urlParams.delete('width');
    
    const baseSrc = `${baseUrl}?${urlParams.toString()}`;
    
    // 各解像度のsrcset生成
    const widths = [400, 600, 800, 1000, 1200, 1400, 1600];
    const srcsetArray = widths.map(width => `${baseSrc}&width=${width} ${width}w`);
    
    const srcset = srcsetArray.join(', ');
    const sizes = '(min-width: 1300px) 660px, (min-width: 990px) calc(55.0vw - 10rem), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw / 1 - 4rem)';
    
    return { srcset, sizes };
  }

  // 高解像度画像URL生成
  generateHighResImageUrl(originalSrc) {
    // 既存のwidth=500を除去して、高解像度版を生成
    const baseUrl = originalSrc.split('?')[0];
    const urlParams = new URLSearchParams(originalSrc.split('?')[1] || '');
    
    // width=500を削除
    urlParams.delete('width');
    
    // 高解像度用のwidth設定（メイン画像用）
    urlParams.set('width', '1200');
    
    return `${baseUrl}?${urlParams.toString()}`;
  }

  // srcset生成（レスポンシブ対応）
  generateSrcset(originalSrc) {
    const baseUrl = originalSrc.split('?')[0];
    const urlParams = new URLSearchParams(originalSrc.split('?')[1] || '');
    
    // width削除
    urlParams.delete('width');
    
    const baseSrc = `${baseUrl}?${urlParams.toString()}`;
    
    // 各解像度のsrcset生成
    const widths = [400, 600, 800, 1000, 1200, 1400, 1600];
    const srcsetArray = widths.map(width => `${baseSrc}&width=${width} ${width}w`);
    
    const srcset = srcsetArray.join(', ');
    const sizes = '(min-width: 1300px) 660px, (min-width: 990px) calc(55.0vw - 10rem), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw / 1 - 4rem)';
    
    return { srcset, sizes };
  }

  // サムネイル用URL生成（小さいサイズ）
  generateThumbnailUrl(mainImageSrc) {
    const baseUrl = mainImageSrc.split('?')[0];
    const urlParams = new URLSearchParams(mainImageSrc.split('?')[1] || '');
    
    // サムネイル用は200px程度で十分
    urlParams.set('width', '200');
    
    return `${baseUrl}?${urlParams.toString()}`;
  }
  extractInfoFromArea(infoArea) {
    const metadata = { model: '', size: '', color: '' };
    
    if (!infoArea) return metadata;
    
    const paragraphs = infoArea.querySelectorAll('p');
    paragraphs.forEach(p => {
      const text = p.textContent.trim();
      
      if (text.includes('モデル:')) {
        metadata.model = text.replace('モデル:', '').trim();
      } else if (text.includes('サイズ:')) {
        metadata.size = text.replace('サイズ:', '').trim();
      } else if (text.includes('カラー:')) {
        metadata.color = text.replace('カラー:', '').trim();
      }
    });
    
    return metadata;
  }

  // スライダーUI作成
  createSliderInterface() {
    const container = document.getElementById('sliderContainer');
    
    if (!container) {
      console.error('❌ sliderContainer要素が見つかりません');
      // フォールバック: product__media-wrapper内に作成
      const mediaWrapper = document.querySelector('.product__media-wrapper');
      if (mediaWrapper) {
        const fallbackContainer = document.createElement('div');
        fallbackContainer.className = 'slider-container';
        fallbackContainer.id = 'sliderContainer';
        mediaWrapper.appendChild(fallbackContainer);
        this.createSliderContent(fallbackContainer);
      } else {
        console.error('❌ 適切なコンテナが見つかりません');
        return;
      }
    } else {
      this.createSliderContent(container);
    }
  }

  createSliderContent(container) {
    container.innerHTML = `
      <section class="slider-main-section">
        <div class="slider-main-image" id="sliderMainImage">
          <img id="mainImage" src="" alt="メイン画像" />
          <div class="slider-nav-hint left">←</div>
          <div class="slider-nav-hint right">→</div>
        </div>
        <div class="slider-main-info" id="sliderMainInfo">
          <!-- 動的に生成 -->
        </div>
      </section>
      
      <div class="slider-thumbnail-container">
        <button class="slider-nav-btn" id="prevBtn">←</button>
        <div class="slider-thumbnail-viewport">
          <div class="slider-thumbnail-wrapper" id="thumbnailWrapper">
            <!-- 動的に生成 -->
          </div>
        </div>
        <button class="slider-nav-btn" id="nextBtn">→</button>
      </div>
    `;

    // サムネイル生成
    this.generateThumbnails();
  }

  // サムネイル生成
  generateThumbnails() {
    const wrapper = document.getElementById('thumbnailWrapper');
    
    this.imageData.forEach((data, index) => {
      const thumbnail = document.createElement('div');
      thumbnail.className = `slider-thumbnail ${index === 0 ? 'active' : ''}`;
      thumbnail.setAttribute('data-index', index);
      
      const infoItems = [data.size, data.color].filter(item => item.trim());
      const infoText = infoItems.length > 0 ? infoItems.join(' / ') : ``;
      
      thumbnail.innerHTML = `
        <img src="${data.src}" alt="${data.alt}" />
      `;
      
      thumbnail.addEventListener('click', () => this.selectImage(index));
      wrapper.appendChild(thumbnail);
    });
  }

  // イベント設定
  setupEvents() {
    this.mainImageElement = document.getElementById('sliderMainImage');
    this.mainImage = document.getElementById('mainImage');
    this.mainInfo = document.getElementById('sliderMainInfo');
    this.thumbnailWrapper = document.getElementById('thumbnailWrapper');
    this.thumbnailViewport = document.querySelector('.slider-thumbnail-viewport');
    this.prevBtn = document.getElementById('prevBtn');
    this.nextBtn = document.getElementById('nextBtn');

    // メイン画像イベント
    this.setupMainImageEvents();
    
    // サムネイルスワイプイベント（スマホのみ）
    this.setupThumbnailSwipeEvents();
    
    // ボタンイベント
    this.prevBtn.addEventListener('click', () => this.scrollThumbnails('right'));
    this.nextBtn.addEventListener('click', () => this.scrollThumbnails('left'));
    
    // キーボード
    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') this.navigate('prev');
      if (e.key === 'ArrowRight') this.navigate('next');
    });
    
    // レスポンシブ
    window.addEventListener('resize', () => this.updateLayout());
  }

  // サムネイルスワイプイベント設定
  setupThumbnailSwipeEvents() {
    if (!this.thumbnailViewport) return;
    
    // スマホサイズかどうかを判定
    const isMobile = () => window.innerWidth <= 768;
    
    this.thumbnailViewport.addEventListener('touchstart', (e) => {
      if (!isMobile()) return; // スマホサイズでない場合は無効
      
      const touch = e.touches[0];
      this.thumbnailTouchStartX = touch.clientX;
      this.thumbnailTouchStartY = touch.clientY;
      this.thumbnailStartScrollPosition = this.scrollPosition;
      this.thumbnailIsSwiping = false;
      
      // アニメーションを一時停止してスムーズなドラッグを実現
      this.thumbnailWrapper.style.transition = 'none';
    }, { passive: true });
    
    this.thumbnailViewport.addEventListener('touchmove', (e) => {
      if (!isMobile()) return;
      
      const touch = e.touches[0];
      const deltaX = touch.clientX - this.thumbnailTouchStartX;
      const deltaY = Math.abs(touch.clientY - this.thumbnailTouchStartY);
      
      // 横方向の動きが縦方向より大きい場合のみ横スクロール処理
      if (Math.abs(deltaX) > deltaY && Math.abs(deltaX) > 10) {
        e.preventDefault(); // 画面の横スクロールを防止
        this.thumbnailIsSwiping = true;
        
        // 指の動きに合わせてリアルタイムでサムネイルを移動
        let newPosition = this.thumbnailStartScrollPosition - deltaX;
        
        // 境界値チェック（ループのため境界を超えても表示）
        const containerWidth = this.thumbnailViewport.offsetWidth;
        const maxScroll = this.thumbnailWrapper.scrollWidth - containerWidth;
        
        // 境界を超えた場合の処理（抵抗感を追加）
        if (newPosition < 0) {
          newPosition = newPosition * 0.3; // 左端での抵抗
        } else if (newPosition > maxScroll) {
          newPosition = maxScroll + (newPosition - maxScroll) * 0.3; // 右端での抵抗
        }
        
        this.scrollPosition = newPosition;
        this.thumbnailWrapper.style.transform = `translateX(-${this.scrollPosition}px)`;
      }
    }, { passive: false });
    
    this.thumbnailViewport.addEventListener('touchend', (e) => {
      if (!isMobile()) return; // スマホサイズでない場合は無効
      
      // アニメーションを復活
      this.thumbnailWrapper.style.transition = 'transform 0.3s ease';
      
      if (!this.thumbnailIsSwiping) return;
      
      const touch = e.changedTouches[0];
      const deltaX = this.thumbnailTouchStartX - touch.clientX;
      const swipeDistance = Math.abs(deltaX);
      
      // スワイプ距離が30px以上の場合のみ方向判定
      if (swipeDistance > 30) {
        if (deltaX > 0) {
          // 左スワイプ：次のサムネイルへ
          this.smoothScrollThumbnails('next');
        } else {
          // 右スワイプ：前のサムネイルへ
          this.smoothScrollThumbnails('prev');
        }
      } else {
        // 小さなスワイプの場合は最も近い画像位置にスナップ
        this.snapToNearestThumbnail();
      }
      
      this.thumbnailIsSwiping = false;
    }, { passive: true });
  }

  // スムーズな1枚ずつサムネイルスクロール（連続スクロール・ループ対応）
  smoothScrollThumbnails(direction) {
    const thumbnails = this.thumbnailWrapper.querySelectorAll('.slider-thumbnail');
    if (thumbnails.length === 0) return;

    // 現在最も中央に近い画像を探す
    const containerWidth = this.thumbnailViewport.offsetWidth;
    const containerCenter = containerWidth / 2;
    let currentCenterIndex = 0;
    let minDistance = Infinity;

    thumbnails.forEach((thumbnail, index) => {
      const thumbnailLeft = thumbnail.offsetLeft;
      const thumbnailCenter = thumbnailLeft + thumbnail.offsetWidth / 2 - this.scrollPosition;
      const distance = Math.abs(thumbnailCenter - containerCenter);
      
      if (distance < minDistance) {
        minDistance = distance;
        currentCenterIndex = index;
      }
    });

    // 次のターゲットインデックスを計算（ループ対応）
    let targetIndex;
    if (direction === 'next') {
      targetIndex = currentCenterIndex >= thumbnails.length - 1 ? 0 : currentCenterIndex + 1;
    } else {
      targetIndex = currentCenterIndex <= 0 ? thumbnails.length - 1 : currentCenterIndex - 1;
    }

    this.scrollToThumbnailIndex(targetIndex);
  }

  // 指定されたインデックスの画像を中央に配置
  scrollToThumbnailIndex(index) {
    const thumbnails = this.thumbnailWrapper.querySelectorAll('.slider-thumbnail');
    if (!thumbnails[index]) return;

    const containerWidth = this.thumbnailViewport.offsetWidth;
    const thumbnail = thumbnails[index];
    const thumbnailLeft = thumbnail.offsetLeft;
    const thumbnailWidth = thumbnail.offsetWidth;
    
    // 画像を中央に配置
    let targetPosition = thumbnailLeft - (containerWidth - thumbnailWidth) / 2;
    
    // 境界値チェック（ループのため）
    const maxScroll = this.thumbnailWrapper.scrollWidth - containerWidth;
    targetPosition = Math.max(0, Math.min(maxScroll, targetPosition));
    
    this.scrollPosition = targetPosition;
    this.thumbnailScrollIndex = index;
    this.thumbnailWrapper.style.transform = `translateX(-${this.scrollPosition}px)`;
  }

  // サムネイルスクロール機能（PC用・ループ対応）
  scrollThumbnails(direction) {
    const thumbnails = this.thumbnailWrapper.querySelectorAll('.slider-thumbnail');
    const containerWidth = this.thumbnailViewport.offsetWidth;
    
    // PC用は複数枚をスクロールしつつループ対応
    const scrollAmount = containerWidth * 0.7;
    
    if (direction === 'left') {
      const maxScroll = this.thumbnailWrapper.scrollWidth - containerWidth;
      if (this.scrollPosition >= maxScroll) {
        // 最後まで行った場合は最初に戻る
        this.scrollPosition = 0;
      } else {
        this.scrollPosition = Math.min(maxScroll, this.scrollPosition + scrollAmount);
      }
    } else {
      if (this.scrollPosition <= 0) {
        // 最初の場合は最後に移動
        const maxScroll = this.thumbnailWrapper.scrollWidth - containerWidth;
        this.scrollPosition = maxScroll;
      } else {
        this.scrollPosition = Math.max(0, this.scrollPosition - scrollAmount);
      }
    }
    
    this.thumbnailWrapper.style.transform = `translateX(-${this.scrollPosition}px)`;
  }

  setupMainImageEvents() {
    // マウスクリック（PCでは従来通り）
    this.mainImageElement.addEventListener('click', (e) => this.handleClick(e));
    
    // タッチイベント（スマホ用・改良版）
    this.mainImageElement.addEventListener('touchstart', (e) => {
      const touch = e.touches[0];
      this.touchStartX = touch.clientX;
      this.touchStartY = touch.clientY;
      this.touchStartTime = Date.now();
    });
    
    this.mainImageElement.addEventListener('touchend', (e) => {
      e.preventDefault();
      
      const touch = e.changedTouches[0];
      const endX = touch.clientX;
      const endY = touch.clientY;
      const endTime = Date.now();
      
      // 移動距離を計算
      const deltaX = Math.abs(endX - this.touchStartX);
      const deltaY = Math.abs(endY - this.touchStartY);
      const totalDistance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
      
      // タッチ時間を計算
      const touchDuration = endTime - this.touchStartTime;
      
      // 意図的なタップかどうかを判定
      const isIntentionalTap = 
        totalDistance < 20 &&      // 移動距離が20px未満
        touchDuration < 500;       // タッチ時間が500ms未満
      
      if (isIntentionalTap) {
        // 意図的なタップ：画像切り替え実行
        this.handleClick({
          clientX: this.touchStartX,
          clientY: this.touchStartY
        });
      }
      // それ以外（スクロール等）は何もしない
    });
  }

  handleClick(e) {
    const rect = this.mainImageElement.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const centerX = rect.width / 2;
    
    if (clickX < centerX) {
      // 左半分をクリック/タッチ = 前の画像
      this.navigate('prev');
    } else {
      // 右半分をクリック/タッチ = 次の画像
      this.navigate('next');
    }
  }



  navigate(direction) {
    if (this.imageData.length <= 1) return;
    
    let newIndex;
    if (direction === 'prev') {
      newIndex = this.currentIndex === 0 ? this.imageData.length - 1 : this.currentIndex - 1;
    } else {
      newIndex = this.currentIndex === this.imageData.length - 1 ? 0 : this.currentIndex + 1;
    }
    
    this.selectImage(newIndex);
  }

  selectImage(index) {
    if (index < 0 || index >= this.imageData.length) return;
    
    const data = this.imageData[index];
    
    // メイン画像更新（高解像度対応）
    this.mainImage.src = data.src;
    this.mainImage.srcset = data.srcset;
    this.mainImage.sizes = data.sizes;
    this.mainImage.alt = data.alt;
    
    // 情報更新
    this.updateMainInfo(data);
    
    // サムネイル更新
    this.updateThumbnails(index);
    
    this.currentIndex = index;
    this.ensureThumbnailVisible(index);
  }

  updateMainInfo(data) {
    this.mainInfo.innerHTML = '';
    
    if (data.model.trim()) {
      const div = document.createElement('div');
      div.innerHTML = `<span>モデル: ${data.model}</span>`;
      this.mainInfo.appendChild(div);
    }
    
    if (data.size.trim()) {
      const div = document.createElement('div');
      div.innerHTML = `<span>サイズ: ${data.size}</span>`;
      this.mainInfo.appendChild(div);
    }
    
    if (data.color.trim()) {
      const div = document.createElement('div');
      div.innerHTML = `<span>カラー: ${data.color}</span>`;
      this.mainInfo.appendChild(div);
    }
  }

  updateThumbnails(activeIndex) {
    const thumbnails = this.thumbnailWrapper.querySelectorAll('.slider-thumbnail');
    thumbnails.forEach((thumb, index) => {
      thumb.classList.toggle('active', index === activeIndex);
    });
  }

  ensureThumbnailVisible(index) {
    // 連続スクロールモードでは指定された画像を中央に配置
    this.scrollToThumbnailIndex(index);
  }

  updateLayout() {
    this.scrollPosition = 0;
    this.thumbnailScrollIndex = 0; // スクロールインデックスもリセット
    this.thumbnailWrapper.style.transform = 'translateX(0)';
  }

  showNotAvailable() {
    const container = document.getElementById('sliderContainer');
    container.innerHTML = `
      <div class="slider-not-available">
        <p>この商品にはモデル着用画像がありません</p>
      </div>
    `;
  }
}

// 初期化
document.addEventListener('DOMContentLoaded', () => {
  console.log('🛍️ Shopify直接変換スライダーを初期化中...');
  new DirectLiquidSlider();
});